"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const categories = [{
  title: "Mobile Tyre Fitting",
  description: "Professional fitting at your home, work, or roadside. Includes new valves and precision wheel balancing as standard.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/mobile_tyre_fitting_leeds.png",
  link: "/TyreServicesPage"
}, {
  title: "Emergency Callouts",
  description: "Rapid 30-60 minute response across Leeds. Our 24/7 emergency team gets you back on the road safely and quickly.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/emergency_roadside_assistance.png",
  link: "/TyreServicesPage"
}, {
  title: "Puncture Repair",
  description: "Safe, permanent repairs for minor tread damage. A cost-effective alternative to replacement when safety allows.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/tyre_puncture_repair_kit.png",
  link: "/TyreServicesPage"
}, {
  title: "Wheel Balancing",
  description: "Eliminate vibrations and prevent uneven wear with our mobile laser balancing technology for a smoother drive.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/precision_wheel_balancing.png",
  link: "/TyreServicesPage"
}];
function CategoryTile({
  category,
  index
}: {
  category: typeof categories[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <Link to={category.link} data-index={index} ref={ref as React.RefObject<HTMLAnchorElement>} className={`group relative block aspect-[3/4] w-full overflow-hidden bg-secondary transition-all duration-1000 ease-out rounded-lg shadow-lg ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
      {}
      <img src={category.image} alt={category.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
      
      {}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px] transition-colors duration-700 ease-out group-hover:bg-black/70" />

      {}
      <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-10">
        <div className="translate-y-8 transition-transform duration-500 ease-out group-hover:translate-y-0">
          <h3 className="mb-4 font-default text-3xl font-bold text-white tracking-tight drop-shadow-lg md:text-4xl">
            {category.title}
          </h3>
          <p className="font-default text-base text-white/90 opacity-0 drop-shadow transition-opacity delay-100 duration-500 ease-out group-hover:opacity-100 md:text-lg">
            {category.description}
          </p>
        </div>
      </div>
    </Link>;
}
export default function MenuCategories() {
  return <section data-section-id="223402" id="our-full-range-of-expertise" className="relative bg-background text-foreground py-24 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col gap-16 lg:flex-row lg:gap-24">
          
          {}
          <div className="lg:w-1/3">
            <div className="sticky top-32 flex flex-col items-start">
              <span className="mb-4 font-mono text-sm font-bold uppercase tracking-widest text-primary">
                Expert Solutions
              </span>
              <h2 className="mb-6 font-default text-4xl font-bold leading-tight text-foreground md:text-5xl lg:text-6xl uppercase tracking-tighter">
                Our Full Range of Expertise
              </h2>
              <p className="mb-8 font-default text-lg text-muted-foreground leading-relaxed">
                From emergency roadside assistance to scheduled home fittings, Drive Mobile Tyres Leeds provides a comprehensive suite of automotive services designed to keep you moving 24/7.
              </p>
              <Button asChild variant="outline" size="lg" className="rounded-full border-primary text-primary hover:bg-primary hover:text-primary-foreground shadow-md hover:shadow-primary/20 transition-all">
                <Link to="#">
                  View All Services
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:w-2/3 lg:gap-8">
            <div className="flex flex-col gap-6 lg:gap-8 lg:pt-24">
              {categories.filter((_, i) => i % 2 === 0).map((category, i) => <CategoryTile key={category.title} category={category} index={i * 2} />)}
            </div>
            <div className="flex flex-col gap-6 lg:gap-8">
              {categories.filter((_, i) => i % 2 !== 0).map((category, i) => <CategoryTile key={category.title} category={category} index={i * 2 + 1} />)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}